import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const DisabledText = () => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center' }}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {t('socialAccounts.disabledText')}
      </Text>
    </div>
  );
};

export default DisabledText;
